import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class BolgeKoduAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "BolgeKoduListe";
        super(baseUrl);
    }
    getBolgeKoduiste(bolgeKodu?: number) {

        return this.get("", { params: { bolgeKodu: bolgeKodu } });
    }
}
export default new BolgeKoduAPI();
class BolgeKoduListeRequest {
    public bolgeKodu?: number;
    constructor(bolgeKodu?: number) {

        this.bolgeKodu = bolgeKodu;

    }
}
export { BolgeKoduListeRequest };